import { render, staticRenderFns } from "./FieldWorkplaceMaterialWrite.vue?vue&type=template&id=38bed01b&scoped=true"
import script from "./FieldWorkplaceMaterialWrite.vue?vue&type=script&lang=js"
export * from "./FieldWorkplaceMaterialWrite.vue?vue&type=script&lang=js"
import style0 from "./FieldWorkplaceMaterialWrite.vue?vue&type=style&index=0&id=38bed01b&prod&lang=scss&scoped=true"
import style1 from "./FieldWorkplaceMaterialWrite.vue?vue&type=style&index=1&id=38bed01b&prod&scoped=true&lang=scss"
import style2 from "./FieldWorkplaceMaterialWrite.vue?vue&type=style&index=2&id=38bed01b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bed01b",
  null
  
)

export default component.exports